import React from 'react';
import { useColors } from '../contexts/ColorContext';

function ServiceCard({ title, description, icon }) {
  const { getClasses } = useColors();

  return (
    <div className={`bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border-t-4 ${getClasses('primary-border')}`}>
      <div className={getClasses('primary-text')}>
        {icon}
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
}

function Services() {
  const { getClasses } = useColors();

  const electricalServices = [
    {
      title: "Instalaciones Eléctricas Comerciales",
      description: "Diseño e instalación de sistemas eléctricos seguros y eficientes para pequeñas y medianas empresas.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      title: "Electrónica Naval",
      description: "Soluciones eléctricas especializadas para yates y embarcaciones, incluyendo sistemas de potencia y electrónica de navegación.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      )
    },
    {
      title: "Sistemas Eléctricos Industriales",
      description: "Instalación y mantenimiento de sistemas eléctricos para complejos industriales, enfocados en seguridad y eficiencia energética.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
        </svg>
      )
    }
  ];

  const webServices = [
    {
      title: "Desarrollo Web Personalizado",
      description: "Creación de sitios web profesionales y aplicaciones web adaptadas a las necesidades específicas de su negocio.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      title: "Infraestructura en la Nube",
      description: "Evaluación, planificación e implementación de soluciones de infraestructura en la nube para optimizar sus operaciones digitales.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.5 16a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.977A4.5 4.5 0 1113.5 16h-8z" />
        </svg>
      )
    },
    {
      title: "Consultoría Tecnológica",
      description: "Asesoramiento experto para ayudar a su empresa a seleccionar e implementar las mejores soluciones tecnológicas para sus objetivos de negocio.",
      icon: (
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
      )
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className={`text-3xl font-bold ${getClasses('secondary-text')} mb-4`}>Nuestros Servicios</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Ofrecemos una amplia gama de servicios profesionales, combinando nuestra experiencia en instalaciones eléctricas y desarrollo web para proporcionar soluciones completas.
          </p>
        </div>

        <div className="mb-16">
          <h3 className={`text-2xl font-bold ${getClasses('primary-text')} mb-8 text-center`}>Servicios Eléctricos</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {electricalServices.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                icon={service.icon}
              />
            ))}
          </div>
        </div>

        <div>
          <h3 className={`text-2xl font-bold ${getClasses('primary-text')} mb-8 text-center`}>Servicios de Desarrollo Web</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {webServices.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                icon={service.icon}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
